import o from "./ghl-ui.es1466.js";
import e from "./ghl-ui.es1650.js";
function f(t) {
  var r = e(t, "string");
  return o(r) === "symbol" ? r : String(r);
}
export {
  f as default
};
